import { createUseStyles } from 'react-jss'

export const useStyle = createUseStyles({
  buttonContainer: {
    width: 120
  }
})
